import { render, staticRenderFns } from "./FolderOpen.vue?vue&type=template&id=01ae1c8e&"
import script from "./FolderOpen.vue?vue&type=script&lang=js&"
export * from "./FolderOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports